import { render, staticRenderFns } from "./EmergencyAddressPanel.vue?vue&type=template&id=22f287e1&scoped=true"
import script from "./EmergencyAddressPanel.vue?vue&type=script&lang=js"
export * from "./EmergencyAddressPanel.vue?vue&type=script&lang=js"
import style0 from "./EmergencyAddressPanel.vue?vue&type=style&index=0&id=22f287e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f287e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f287e1')) {
      api.createRecord('22f287e1', component.options)
    } else {
      api.reload('22f287e1', component.options)
    }
    module.hot.accept("./EmergencyAddressPanel.vue?vue&type=template&id=22f287e1&scoped=true", function () {
      api.rerender('22f287e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/EmergencyAddressPanel.vue"
export default component.exports